<template>
  <div id="comment" class="full">
    <div class="mainTitle1 textbox">
      <h3>Trusted By Our Customers</h3>
      <p>Let our customers to personally explain the use of our services and products.</p>
    </div>
    <div class="itembox">
      <swiper class="swiper1" ref="swiper1" :options="commentopt" :auto-update='true'>
        <swiper-slide class="item" v-for="(item,index) in list" :key="index">
          <div class="imgbox">
            <img :src="item.img" alt="" class="head">
            <img src="../assets/img/comment_icon.png" alt="" class="icon">
          </div>
          <el-rate class="rate" v-model="rate" disabled></el-rate>
          <p>{{item.text}}</p>
          <span>{{item.name}}</span>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev sbp2" slot="button-prev"></div>
      <div class="swiper-button-next sbn2" slot="button-next"></div>
<!--      <div class="item" v-for="(item,index) in list" :key="index">-->
<!--        <div class="imgbox">-->
<!--          <img :src="item.img" alt="" class="head">-->
<!--          <img src="../assets/img/comment_icon.png" alt="" class="icon">-->
<!--        </div>-->
<!--        <el-rate class="rate" v-model="rate" disabled></el-rate>-->
<!--        <p>{{item.text}}</p>-->
<!--        <span>{{item.name}}</span>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "comment",
  props:{
    comopt:Object,
  },
  data(){
    return{
      rate:5,
      list:[
        {
          img:require('../assets/img/comment_img1.jpg'),
          name:'Laura , the United States',
          text:'Since installing Brotex products, the sonic difference has been really astounding in our concert hall. It was a really great auditory experience.',
        },
        {
          img:require('../assets/img/comment_img2.jpg'),
          name:'Ella , HK of China',
          text:'We are delighted to work with Brotex Acoustics. Their products and expertise have allowed us to set up one of our studios very quickly and with great results. ',
        },
        {
          img:require('../assets/img/comment_img3.jpg'),
          name:'Jimmy , UAE',
          text:'The perforated acoustic panels of Brotex are really good materials and look. They clean up all the extra reverb in the room, and we didn\'t need to fill the whole room with them.',
        },
        {
          img:require('../assets/img/comment_img4.jpg'),
          name:'Peter , the United States',
          text:'Our panels arrived on time without any delay. Thank you very much for completing such a large order perfectly. Looking forward to our next cooperation!',
        },
      ],
      commentopt:{
        slidesPerView: 3,
        spaceBetween: 30,
        slidesPerColumnFill:'row',
        navigation: {
          nextEl: '.sbn2',
          prevEl: '.sbp2'
        },
      },
    }
  },
  watch:{
    comopt(newval){
      this.commentopt=newval
      // console.log('changed')
    },
  },
}
</script>

<style lang="less" scoped>
#comment{background: url("../assets/img/comment_bg.png") no-repeat 100% 0%/40% rgba(247,248,252);padding: 110px 280px;
  .itembox{display: flex;position: relative;
    .item{display: flex;flex-direction: column;align-items: center;background: white;width: calc(33% - 26.66666px);padding: 35px;
      .imgbox{position: relative;
        .head{border-radius: 50%;width: 90px;height: 90px;object-fit: cover;}
        .icon{position: absolute;bottom: -19%;right: -35%;transform: translate(-50%,-50%);}
      }
      .rate{margin: 30px 0;
        /deep/ .el-rate__icon{font-size: 26px;}
      }
      p{font: 18px/26px Poppins-Regular;color: #657788;margin-bottom: 45px;text-align: center;}
      span{font: 18px Poppins-Medium;color: @main-c4;}
    }
  }
}
</style>